import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  saveModule: ['mod', 'onSuccess', 'onError'],
  removeModule: ['mod', 'onSuccess', 'onError'],
  moduleError: ['error']
})

const saveModule = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const removeModule = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const moduleError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.MODULE_ERROR]: moduleError,

  [Types.SAVE_MODULE]: saveModule,
  [Types.REMOVE_MODULE]: removeModule,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as ModuleTypes,
  Creators as ModuleActions
}
